import { ColorBoundary } from "..";
import { get_unique_values } from "../../../../misc/array";
import * as MathHelper from "../../../../misc/math";
import { ColorBoundaryContainer } from "../containers/ColorBoundaryContainer";
export class ColorCalculator {
    constructor() {
        this.numeric_values = [];
        this.categorical_values = [];
        this.edge_count = 0;
        this.colors = [];
        this.boundaries = new ColorBoundaryContainer();
        this.color_map = () => '';
    }
    get values() {
        return this.numeric_values.length === 0 ? this.categorical_values : this.numeric_values;
    }
    load(values, colors) {
        this.zero();
        this.colors = colors;
        this.edge_count = colors.length + 1;
        if (values.every(v => typeof v === "number")) {
            this.numeric_values = values;
        }
        else
            this.categorical_values = values;
    }
    get_bounds() {
        return this.boundaries;
    }
    get_color_map(gradient) {
        if (gradient) {
            this.create_gradient_map();
        }
        else {
            this.create_categorical_map();
        }
        this.set_counts();
        return this.color_map;
    }
    zero() {
        this.numeric_values = [];
        this.categorical_values = [];
        this.edge_count = 0;
        this.colors = [];
        this.boundaries = new ColorBoundaryContainer();
    }
    set_counts() {
        const parsed = this.values.map(v => this.color_map(v));
        for (let boundary of this.boundaries) {
            boundary.count = parsed.filter(c => c === boundary.color).length;
        }
    }
    calculate_edges() {
        const { max, min, ..._ } = MathHelper.get_stats(this.numeric_values);
        const [true_min, true_max] = [Math.min(...this.numeric_values), Math.max(...this.numeric_values)];
        if (min === max)
            return [true_min, true_max];
        const num_outlier_edges = (max < true_max ? 1 : 0) + (min > true_min ? 1 : 0);
        let main_edges = MathHelper.interpolate(min, max, this.edge_count - num_outlier_edges);
        if (num_outlier_edges === 0)
            return main_edges;
        if (min > true_min)
            main_edges.unshift(true_min);
        if (max < true_max)
            main_edges.push(true_max);
        return main_edges;
    }
    create_gradient_map() {
        let edges = this.calculate_edges();
        for (let i = 0; i < edges.length - 1; i++) {
            let interval_lower_bound = Math.round(edges[i] * 100) / 100;
            let interval_upper_bound = Math.round(edges[i + 1] * 100) / 100;
            const color_record = {
                label: `${interval_lower_bound} - ${interval_upper_bound}`,
                color: this.colors[i],
                count: 0
            };
            this.boundaries.push(ColorBoundary.from(color_record));
        }
        this.color_map = (value) => {
            if (value == null)
                value = 0;
            let idx = 0;
            for (let i = 1; i < edges.length; i++) {
                if (value <= edges[i])
                    break;
                idx = i;
            }
            return this.colors[idx];
        };
    }
    create_categorical_map() {
        let i = 0;
        let itercolors = {
            next: () => this.colors[i++ % this.colors.length]
        };
        let uniques = get_unique_values(this.values);
        for (let val of uniques) {
            let color_record = {
                label: val.toString(),
                color: itercolors.next(),
                count: 0
            };
            this.boundaries.push(ColorBoundary.from(color_record));
        }
        this.color_map = (val) => {
            let record = this.boundaries.find(b => b.label === val.toString());
            if (record)
                return record.color;
            return '#FFFFFF';
        };
    }
}
